module.exports = __webpack_public_path__ + "static_portal/img/blended_back_arms_rowing_style_boat.b36901cd.webp";